import PlaceOrder from "./PlaceOrder";

export default function TradeOrder() {
  return <PlaceOrder />;
}
